import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home";
import RaspberryPi from "./pages/RaspberryPi";
import CV from "./pages/CV";
import Passions from "./pages/Passions";
import AVConsulting from "./pages/AVConsulting";
import Archive from "./pages/Archive";
import Gallery from "./pages/Acting/Gallery";
import Details from "./pages/Acting/Details";
import Games from "./pages/Games";
import GamePlayer from "./pages/GamePlayer";
import NotFound from "./pages/NotFound";
import StickyHeader from "./components/StickyHeader";
import Footer from "./main/Footer";
import GoogleAnalytics from "./components/GoogleAnalytics";

const CANONICAL_ORIGIN = "https://waltyao.com";

function CanonicalLink() {
  const { pathname } = useLocation();

  useEffect(() => {
    const href =
      pathname === "/"
        ? `${CANONICAL_ORIGIN}/`
        : `${CANONICAL_ORIGIN}${pathname}`;

    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = href;
  }, [pathname]);

  return null;
}

function AppShell() {
  return (
    <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white">
      <StickyHeader />
      <div className="overflow-y-auto scrollbar-styled" style={{ height: "100vh", paddingTop: "80px" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/raspberry-pi" element={<RaspberryPi />} />
          <Route path="/resume" element={<CV />} />
          <Route path="/cv" element={<Navigate to="/resume" replace />} />
          <Route path="/about" element={<Navigate to="/resume" replace />} />
          <Route path="/passions" element={<Passions />} />
          <Route path="/av-consulting" element={<AVConsulting />} />
          <Route path="/acting" element={<Gallery />} />
          <Route path="/acting/:gigName" element={<Details />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/games" element={<Games />} />
          <Route path="/games/:slug" element={<GamePlayer />} />
          <Route path="/doom" element={<Navigate to="/games/doom" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </div>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <Router>
      <GoogleAnalytics />
      <CanonicalLink />
      <AppShell />
    </Router>
  );
}

export default App;
